//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'BowelLength',
  data() {
    return {
      defaultJson:{
        "Colon length": "结肠长度",
        "Small bowel length": "小肠长度",
        "Patient's height": "患者身高"
      },
      form:{
        height:'',
      },
      hasScore:false,
      disabled:false,
      sbl:'--',
      cl:'--',
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // e^(6.741 - (80.409 / height))
        self.sbl = String(Math.pow(Math.E,(6.741 - (80.409 / form.height)))) 
        // 	0.111 * (height^1.521)
        self.cl = 	0.111 *Math.pow(form.height,1.521)

        let result = self.cl
        
        self.hasScore = true
        return String(result.toFixed(0))
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/BowelLength.vue